<template>
  <div class="full-width small-top">
    <div class="card card--transparent">
      <h1 style="text-align: center">{{ kpi.name }}</h1>
      <well-being-chart :chartData="info" :options="options" style="height: 25vh; width: 100%; min-height: 250px" />

    </div>
      <modal v-if="modalData" @close="modalData=''" title="Reflection" btn="Close" @submit="modalData=''">
        <div>
          What helped or hindered you from doing your best today?
          What will you do tomorrow to be your best self?
        </div>
        <h5 class="small-top float-right">{{date(modalData.survey__modified_at)}}</h5>
        {{modalData.reflection}}
    </modal>
  </div>
</template>

<script>
import wellBeingChart from "@/components/charts/wellBeing//wellBeingChart";
import Nazgul from "@/services/nazgul";
import modal from "@/components/modal/default";
import moment from "moment";

export default {
  props: { kpi: { data: [] } },
  data() {
    return {
      modalData: "",
      loading: true,
      info: {
        fill: false,
        labels: this.kpi.data.map(d => this.date(d.created_at)),
        datasets: [{
            label: this.kpi.name,
            borderColor: "white",
            pointBorderColor: "white",
            pointBackgroundColor: "white",
            data: this.kpi.data.map(k => k.result),
            fill: false
        }],
      },
      retrievedData: this.kpi.data,
      options: {
        maintainAspectRatio: false,
        legend: false,
        events: ["click"],
        tooltips: {
          callbacks: {
            label: ({ index }) => {
              Nazgul.report("daily_reflection_checked", this.title);
              let point = this.retrievedData[index];
              if (point) {
                this.modalData = point;
              }
              return "";
            }
          },
          displayColors: false
        },
        scales: {
          xAxes: [{
            display: true,
            ticks: {
              fontColor: "white"
            },
          }],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: "white"
              },
              ticks: {
                fontColor: "white",
                beginAtZero: true,
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    date(d) {
      return moment(d).format("MMM DD, YYYY");
    }
  },
  components: {
    wellBeingChart,
    modal
  }
};
</script>